// import React, { useState, useEffect } from 'react';
// import { FaCalculator, FaSpinner, FaCheckCircle, FaTimesCircle, FaInfoCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import { campaignService } from '../../services/companyAuthService';

// const CalculatePayments = () => {
//   const [campaigns, setCampaigns] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [calculating, setCalculating] = useState(false);
//   const [calculationResults, setCalculationResults] = useState([]);
//   const [expandedResults, setExpandedResults] = useState({});
//   const [selectedCampaigns, setSelectedCampaigns] = useState([]);
//   const [showResults, setShowResults] = useState(false);

//   useEffect(() => {
//     fetchCampaigns();
//   }, []);

//   const fetchCampaigns = async () => {
//     try {
//       setLoading(true);
//       const response = await campaignService.getCampaigns();
      
//       if (response.success) {
//         // Filter only active campaigns
//         // API returns campaigns in response.campaigns, not response.data
//         const activeCampaigns = (response.campaigns || response.data || []).filter(
//           campaign => campaign.status === 'active'
//         );
//         setCampaigns(activeCampaigns);
//       }
//     } catch (error) {
//       console.error('Error fetching campaigns:', error);
//       toast.error('Failed to load campaigns');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSelectCampaign = (campaignId) => {
//     setSelectedCampaigns(prev => {
//       if (prev.includes(campaignId)) {
//         return prev.filter(id => id !== campaignId);
//       } else {
//         return [...prev, campaignId];
//       }
//     });
//   };

//   const handleSelectAll = () => {
//     if (selectedCampaigns.length === campaigns.length) {
//       setSelectedCampaigns([]);
//     } else {
//       setSelectedCampaigns(campaigns.map(c => c._id));
//     }
//   };

//   const handleCalculatePayments = async () => {
//     if (selectedCampaigns.length === 0) {
//       toast.warning('Please select at least one campaign');
//       return;
//     }

//     setCalculating(true);
//     setCalculationResults([]);
//     setShowResults(false);

//     const results = [];
    
//     try {
//       for (const campaignId of selectedCampaigns) {
//         const campaign = campaigns.find(c => c._id === campaignId);
        
//         try {
//           // Fetch affiliates for this campaign
//           const affiliatesResponse = await campaignService.getCampaignAffiliates(campaignId);
          
//           if (affiliatesResponse.success && affiliatesResponse.data?.length > 0) {
//             const campaignResult = {
//               campaignId,
//               campaignName: campaign.name,
//               brandName: campaign.brandName || campaign.brandDetails?.name || 'Unknown Brand',
//               affiliates: [],
//               totalRevenue: 0,
//               status: 'success'
//             };

//             // Calculate payment for each affiliate
//             for (const affiliate of affiliatesResponse.data) {
//               try {
//                 const calcResponse = await campaignService.calculateAffiliatePayment(
//                   campaignId,
//                   affiliate.userId
//                 );

//                 if (calcResponse.success) {
//                   const affiliateResult = {
//                     affiliateId: affiliate.userId,
//                     affiliateName: affiliate.firstName && affiliate.lastName 
//                       ? `${affiliate.firstName} ${affiliate.lastName}`
//                       : affiliate.username || 'Unknown',
//                     email: affiliate.email,
//                     instagramId: affiliate.instagramId,
//                     revenue: calcResponse.data?.total?.revenue || 0,
//                     totalDue: calcResponse.data?.incrementalInfo?.totalDue || calcResponse.data?.total?.revenue || 0,
//                     isIncremental: calcResponse.data?.incrementalInfo?.isIncremental || false,
//                     calculationData: calcResponse.data,
//                     status: 'success'
//                   };

//                   campaignResult.affiliates.push(affiliateResult);
//                   campaignResult.totalRevenue += affiliateResult.revenue;
//                 } else {
//                   campaignResult.affiliates.push({
//                     affiliateId: affiliate.userId,
//                     affiliateName: affiliate.firstName && affiliate.lastName 
//                       ? `${affiliate.firstName} ${affiliate.lastName}`
//                       : affiliate.username || 'Unknown',
//                     email: affiliate.email,
//                     status: 'error',
//                     error: calcResponse.message || 'Calculation failed'
//                   });
//                 }
//               } catch (affiliateError) {
//                 console.error(`Error calculating payment for affiliate ${affiliate.userId}:`, affiliateError);
//                 const errorMessage = affiliateError.response?.data?.error?.message 
//                   || affiliateError.response?.data?.message 
//                   || affiliateError.message 
//                   || 'Unknown error';
                
//                 campaignResult.affiliates.push({
//                   affiliateId: affiliate.userId,
//                   affiliateName: affiliate.firstName && affiliate.lastName 
//                     ? `${affiliate.firstName} ${affiliate.lastName}`
//                     : affiliate.username || 'Unknown',
//                   email: affiliate.email,
//                   status: 'error',
//                   error: errorMessage
//                 });
//               }
//             }

//             results.push(campaignResult);
//           } else {
//             results.push({
//               campaignId,
//               campaignName: campaign.name,
//               brandName: campaign.brandName || campaign.brandDetails?.name || 'Unknown Brand',
//               status: 'no_affiliates',
//               message: 'No affiliates found for this campaign'
//             });
//           }
//         } catch (campaignError) {
//           console.error(`Error fetching affiliates for campaign ${campaignId}:`, campaignError);
          
//           // Enhanced error message extraction
//           const errorMessage = campaignError.response?.data?.error?.message 
//             || campaignError.response?.data?.message 
//             || campaignError.message 
//             || 'Failed to process campaign';
          
//           // Check for specific error types
//           let friendlyMessage = errorMessage;
//           if (errorMessage.includes('Document() must be an object')) {
//             friendlyMessage = 'Invalid campaign ID format. Please refresh and try again.';
//           } else if (errorMessage.includes('Error fetching affiliates')) {
//             friendlyMessage = 'Unable to fetch affiliates. Please try again later.';
//           }
          
//           results.push({
//             campaignId,
//             campaignName: campaign.name,
//             brandName: campaign.brandName || campaign.brandDetails?.name || 'Unknown Brand',
//             status: 'error',
//             error: friendlyMessage
//           });
//         }
//       }

//       setCalculationResults(results);
//       setShowResults(true);
      
//       const successCount = results.filter(r => r.status === 'success').length;
//       const errorCount = results.filter(r => r.status === 'error').length;
      
//       if (successCount > 0) {
//         toast.success(`Payment calculation completed for ${successCount} campaign(s)`);
//       }
//       if (errorCount > 0) {
//         toast.warning(`${errorCount} campaign(s) had errors. Check details below.`);
//       }
//     } catch (error) {
//       console.error('Error calculating payments:', error);
//       toast.error('Failed to calculate payments. Please try again.');
//     } finally {
//       setCalculating(false);
//     }
//   };

//   const toggleResultExpansion = (campaignId) => {
//     setExpandedResults(prev => ({
//       ...prev,
//       [campaignId]: !prev[campaignId]
//     }));
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 2
//     }).format(amount || 0);
//   };

//   const getTotalRevenue = () => {
//     return calculationResults.reduce((sum, result) => {
//       return sum + (result.totalRevenue || 0);
//     }, 0);
//   };

//   if (loading) {
//     return (
//       <div className="flex justify-center items-center min-h-screen">
//         <div className="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-orange-500"></div>
//       </div>
//     );
//   }

//   return (
//     <div className="container mx-auto px-4 py-6 max-w-7xl">
//       {/* Header */}
//       <div className="mb-6">
//         <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 flex items-center gap-2">
//           <FaCalculator className="text-orange-500" />
//           Calculate Payments
//         </h1>
//         <p className="text-sm text-gray-600 mt-1">
//           Calculate and review payment details for your campaigns and affiliates
//         </p>
//       </div>

//       {/* Campaigns Selection */}
//       <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mb-6">
//         <div className="flex justify-between items-center mb-4">
//           <h2 className="text-lg font-semibold text-gray-800">Select Campaigns</h2>
//           {campaigns.length > 0 && (
//             <button
//               onClick={handleSelectAll}
//               className="text-sm text-orange-600 hover:text-orange-700 font-medium"
//             >
//               {selectedCampaigns.length === campaigns.length ? 'Deselect All' : 'Select All'}
//             </button>
//           )}
//         </div>

//         {campaigns.length === 0 ? (
//           <div className="text-center py-8 text-gray-500">
//             <FaInfoCircle className="mx-auto text-4xl mb-2" />
//             <p>No active campaigns found</p>
//           </div>
//         ) : (
//           <div className="space-y-2 max-h-96 overflow-y-auto">
//             {campaigns.map((campaign) => (
//               <label
//                 key={campaign._id}
//                 className="flex items-center p-4 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
//               >
//                 <input
//                   type="checkbox"
//                   checked={selectedCampaigns.includes(campaign._id)}
//                   onChange={() => handleSelectCampaign(campaign._id)}
//                   className="w-5 h-5 text-orange-500 border-gray-300 rounded focus:ring-orange-500"
//                 />
//                 <div className="ml-3 flex-1">
//                   <div className="flex items-center justify-between">
//                     <div>
//                       <p className="font-medium text-gray-900">{campaign.name}</p>
//                       <p className="text-sm text-gray-500">
//                         Brand: {campaign.brandDetails?.name || 'Unknown'}
//                       </p>
//                     </div>
//                     <div className="text-right">
//                       <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
//                         {campaign.status}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </label>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Calculate Button */}
//       <div className="mb-6">
//         <button
//           onClick={handleCalculatePayments}
//           disabled={calculating || selectedCampaigns.length === 0}
//           className="w-full flex items-center justify-center px-6 py-4 bg-gradient-to-r from-orange-500 to-orange-600 text-white rounded-xl hover:from-orange-600 hover:to-orange-700 disabled:opacity-50 disabled:cursor-not-allowed font-semibold text-lg shadow-lg hover:shadow-xl transition-all"
//         >
//           {calculating ? (
//             <>
//               <FaSpinner className="mr-2 animate-spin" />
//               Calculating Payments...
//             </>
//           ) : (
//             <>
//               <FaCalculator className="mr-2" />
//               Calculate Payments for Selected Campaigns
//             </>
//           )}
//         </button>
//       </div>

//       {/* Calculation Results */}
//       {showResults && calculationResults.length > 0 && (
//         <div className="space-y-6">
//           {/* Summary Card */}
//           <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-xl shadow-sm border border-green-200 p-6">
//             <h2 className="text-xl font-bold text-gray-800 mb-4">Calculation Summary</h2>
//             <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
//               <div className="bg-white rounded-lg p-4">
//                 <p className="text-sm text-gray-600 mb-1">Total Campaigns</p>
//                 <p className="text-2xl font-bold text-gray-900">{calculationResults.length}</p>
//               </div>
//               <div className="bg-white rounded-lg p-4">
//                 <p className="text-sm text-gray-600 mb-1">Total Affiliates</p>
//                 <p className="text-2xl font-bold text-gray-900">
//                   {calculationResults.reduce((sum, r) => sum + (r.affiliates?.length || 0), 0)}
//                 </p>
//               </div>
//               <div className="bg-white rounded-lg p-4">
//                 <p className="text-sm text-gray-600 mb-1">Total New Revenue</p>
//                 <p className="text-2xl font-bold text-green-600">{formatCurrency(getTotalRevenue())}</p>
//               </div>
//             </div>
//           </div>

//           {/* Detailed Results */}
//           <div className="space-y-4">
//             <h2 className="text-xl font-bold text-gray-800">Detailed Results</h2>
            
//             {calculationResults.map((result) => (
//               <div
//                 key={result.campaignId}
//                 className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden"
//               >
//                 {/* Campaign Header */}
//                 <div
//                   className="flex items-center justify-between p-4 cursor-pointer hover:bg-gray-50 transition-colors"
//                   onClick={() => toggleResultExpansion(result.campaignId)}
//                 >
//                   <div className="flex items-center gap-4 flex-1">
//                     <div className="flex-shrink-0">
//                       {result.status === 'success' ? (
//                         <FaCheckCircle className="text-green-500 text-2xl" />
//                       ) : result.status === 'no_affiliates' ? (
//                         <FaInfoCircle className="text-yellow-500 text-2xl" />
//                       ) : (
//                         <FaTimesCircle className="text-red-500 text-2xl" />
//                       )}
//                     </div>
//                     <div className="flex-1">
//                       <h3 className="font-semibold text-gray-900">{result.campaignName}</h3>
//                       <p className="text-sm text-gray-600">Brand: {result.brandName}</p>
//                       {result.status === 'success' && (
//                         <p className="text-sm text-green-600 font-medium mt-1">
//                           Revenue: {formatCurrency(result.totalRevenue)} • {result.affiliates?.length || 0} affiliate(s)
//                         </p>
//                       )}
//                       {result.status === 'no_affiliates' && (
//                         <p className="text-sm text-yellow-600 mt-1">{result.message}</p>
//                       )}
//                       {result.status === 'error' && (
//                         <p className="text-sm text-red-600 mt-1">{result.error}</p>
//                       )}
//                     </div>
//                   </div>
//                   <div className="flex-shrink-0">
//                     {result.status === 'success' && result.affiliates?.length > 0 && (
//                       expandedResults[result.campaignId] ? (
//                         <FaChevronUp className="text-gray-400" />
//                       ) : (
//                         <FaChevronDown className="text-gray-400" />
//                       )
//                     )}
//                   </div>
//                 </div>

//                 {/* Affiliate Details */}
//                 {expandedResults[result.campaignId] && result.status === 'success' && result.affiliates?.length > 0 && (
//                   <div className="border-t border-gray-200 bg-gray-50 p-4">
//                     <h4 className="font-semibold text-gray-800 mb-3">Affiliate Details</h4>
//                     <div className="space-y-3">
//                       {result.affiliates.map((affiliate, idx) => (
//                         <div
//                           key={affiliate.affiliateId || idx}
//                           className="bg-white rounded-lg p-4 border border-gray-200"
//                         >
//                           <div className="flex items-start justify-between">
//                             <div className="flex-1">
//                               <div className="flex items-center gap-2 mb-2">
//                                 {affiliate.status === 'success' ? (
//                                   <FaCheckCircle className="text-green-500" />
//                                 ) : (
//                                   <FaTimesCircle className="text-red-500" />
//                                 )}
//                                 <span className="font-medium text-gray-900">{affiliate.affiliateName}</span>
//                               </div>
//                               <div className="text-sm text-gray-600 space-y-1">
//                                 <p>Email: {affiliate.email}</p>
//                                 {affiliate.instagramId && (
//                                   <p>Instagram: @{affiliate.instagramId}</p>
//                                 )}
//                               </div>
//                               {affiliate.status === 'success' ? (
//                                 <div className="mt-3 grid grid-cols-2 gap-3">
//                                   <div className="bg-green-50 rounded-lg p-3">
//                                     <p className="text-xs text-gray-600 mb-1">New Revenue</p>
//                                     <p className="font-bold text-green-600">{formatCurrency(affiliate.revenue)}</p>
//                                   </div>
//                                   <div className="bg-orange-50 rounded-lg p-3">
//                                     <p className="text-xs text-gray-600 mb-1">Total Due</p>
//                                     <p className="font-bold text-orange-600">{formatCurrency(affiliate.totalDue)}</p>
//                                   </div>
//                                 </div>
//                               ) : (
//                                 <p className="text-sm text-red-600 mt-2">{affiliate.error}</p>
//                               )}
//                               {affiliate.isIncremental && (
//                                 <div className="mt-2">
//                                   <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
//                                     Incremental Calculation
//                                   </span>
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CalculatePayments;


import React from 'react'

const CalculatePayments = () => {
  return (
    <div>
      <h1>Calculate Payments</h1>
    </div>
  )
}

export default CalculatePayments

